import React, { useEffect, useRef } from "react";
import {CustomToolTip} from "./components/CustomToolTip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const get_image_url = (image) => {
  return (
    `https://caiproduction002.blob.core.windows.net/ira/audit_images/` +
    image +
    `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
  );
};



const ThumbNailImage = (props) => {
  const imageUrl = get_image_url(props.imageName);
  const canvasRef = useRef(null);
  const xmin = props.xmin; // X-coordinate of the top-left corner of the region
  const ymin = props.ymin; // Y-coordinate of the top-left corner of the region
  const xmax = props.xmax; // X-coordinate of the bottom-right corner of the region
  const ymax = props.ymax; // Y-coordinate of the bottom-right corner of the region
  const canvasWidth = 220;
  // console.log(props)
  const copyText = (name) => {
    navigator.clipboard.writeText(name);
  };
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imageUrl;

    const calculateAdjustedHeight = () => {
      const aspectRatio = img.width / img.height;
     // const adjustedWidth = canvasWidth;
    
      // Adjust height based on window height
      const windowHeight = window.innerHeight;
      const maxHeight591 = 200; // Adjust this value based on your preference
      const adjustedWidth = windowHeight <= 600 ? maxHeight591 : canvasWidth;
    
      return adjustedWidth;
    };

    img.onload = async () => {
      // Calculate the aspect ratio of the original image
      const aspectRatio = img.width / img.height;

      // Calculate the canvas dimensions to maintain the aspect ratio
       const adjustedWidth =  calculateAdjustedHeight();
      //const adjustedWidth=canvasWidth;
      const adjustedHeight = canvasWidth / aspectRatio;
      // Set the canvas dimensions
      canvas.width = adjustedWidth;
      canvas.height = adjustedHeight;

      // Draw the full image on the canvas
      ctx.drawImage(img, 0, 0, adjustedWidth, adjustedHeight);

      // Draw borders around the specified region (defined by xmin, ymin, xmax, ymax)
      const borderColor = "#01f8b2";
      const borderWidth = 2;
      ctx.strokeStyle = borderColor;
      ctx.lineWidth = borderWidth;

      ctx.strokeRect(
        xmin * (adjustedWidth / img.width),
        ymin * (adjustedHeight / img.height),
        (xmax - xmin) * (adjustedWidth / img.width),
        (ymax - ymin) * (adjustedHeight / img.height)
      );
    };
  }, [imageUrl, canvasWidth, xmin, ymin, xmax, ymax]);

  return (
    <>
      <div style={{ position: "relative"}}>
        <canvas style={{ justifyContent: "flex-start" }} ref={canvasRef} />
        <CustomToolTip
          title={props.imageName}
          placement="top"
          // classes={{ tooltip: classes.customTooltip }}
          arrow
        >
          <div
            style={{
              position: "absolute",
              bottom: "3px",
              left: "0px",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#d7f3ff",
              fontFamily: "ChalkboardSE-Regular",
              boxSizing: "border-box",
              overflow: "hidden",
              color: "rgba(73 , 148, 236, 0.875)",
              zIndex: "1000",
              fontSize: "12px",
              fontWeight:"550",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              backgroundColor:"#d7f3ff",
              maxWidth: "100%", 
            }}
          >
         
           <div
              style={{
                flex: 1,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {props.imageName}
            </div>
            <ContentCopyIcon
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                fontSize: "15px", color: "74adf0" 
              }}
              onClick={() => copyText(props.imageName)}
            />
          </div>
         
         
        </CustomToolTip>
      </div>
    </>
  );
};

export default ThumbNailImage;
